import { useTheme } from '@mui/material/styles';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

interface SafeMarkdownProps {
  text: string;
  isMenu?: boolean;
  target?: string;
}

export const SafeMarkdown = ({ text, isMenu, target }: SafeMarkdownProps) => {
  const theme = useTheme();

  const linkStyle = isMenu
    ? {
        textDecoration: 'none',
        color: theme.palette.text.primary,
      }
    : {
        textDecoration: 'underline',
        color: theme.palette.info.main,
      };

  return (
    <ReactMarkdown
      allowedElements={['p', 'br', 'a']}
      unwrapDisallowed
      skipHtml
      remarkPlugins={[remarkBreaks]}
      components={{
        p: function Paragraph({ ...props }) {
          return <>{props.children}</>;
        },
        a: function Link({ ...props }) {
          if (isMenu) {
            return <>{props.children}</>;
          }

          return (
            <a
              href={props.href}
              target={target || '_blank'}
              rel="noopener noreferrer"
              style={linkStyle}
              {...props}
            >
              {props.children}
            </a>
          );
        },
      }}
    >
      {text}
    </ReactMarkdown>
  );
};

SafeMarkdown.displayName = 'SafeMarkdown';
